<template>
  <router-view>    
  </router-view>  
</template>

<script>
import Mgr from './services/SecurityService'

export default {
  name: 'App',
  data () {
    return {
      mgr: new Mgr(),
      signedIn: true,
      warningModal: true,
    }    
  },
  mounted () {
    
    this.mgr.getSignedIn().then(
      signIn => {
        this.signedIn = signIn
      },
      err => {
        console.log(err)
      }
    )    
  }
}
</script>

<style lang="scss">
  // Import Main styles for this application
  @import 'assets/scss/style';
</style>
